/* ============================================================
   VS AUTO COLLECTIONS
   First 10 manual + all remaining collections automatic
   ============================================================ */
(function () {
  'use strict';

  function bindCards(section) {
    if (!section) return;

    section.querySelectorAll('[data-vsac-card]').forEach(function (card) {
      if (card.dataset.vsacBound === 'true') return;
      card.dataset.vsacBound = 'true';
/* ============================================================
   VS AUTO COLLECTIONS
   SELECTED COLLECTIONS ONLY
   Dashboard order = storefront order
   ============================================================ */
(function () {
  'use strict';

  function bindCards(section) {
    if (!section) return;

    section.querySelectorAll('[data-vsac-card]').forEach(function (card) {
      if (card.dataset.vsacBound === 'true') return;
      card.dataset.vsacBound = 'true';

      card.addEventListener('mouseenter', function () {
        card.classList.add('vsac__card--active');
      });

      card.addEventListener('mouseleave', function () {
        card.classList.remove('vsac__card--active');
      });
    });
  }

  function initVSAC(section) {
    if (!section || section.dataset.vsacInitialized === 'true') return;

    section.dataset.vsacInitialized = 'true';
    bindCards(section);
  }

  function initAllVSAC() {
    document.querySelectorAll('.vsac').forEach(function (section) {
      initVSAC(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllVSAC);
  } else {
    initAllVSAC();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('.vsac')
      : null;

    if (section) initVSAC(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('.vsac')
      : null;

    if (section) {
      section.dataset.vsacInitialized = 'false';
    }
  });
})();

      card.addEventListener('mouseenter', function () {
        card.classList.add('vsac__card--active');
      });

      card.addEventListener('mouseleave', function () {
        card.classList.remove('vsac__card--active');
      });
    });
  }

  function autoLoadRemainingCollections(section) {
    var state = section.querySelector('[data-vsac-next]');
    var grid = section.querySelector('[data-vsac-grid]');

    if (!state || !grid || section.dataset.vsacAutoLoading === 'true') return;
    section.dataset.vsacAutoLoading = 'true';

    function loadNext() {
      var nextUrl = state.getAttribute('data-vsac-next');

      if (!nextUrl) {
        state.remove();
        return;
      }

      fetch(nextUrl, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Collections request failed');
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextGrid = doc.querySelector('[data-vsac-grid]');
          var nextState = doc.querySelector('[data-vsac-next]');

          if (nextGrid) {
            Array.prototype.slice.call(nextGrid.children).forEach(function (card) {
              grid.appendChild(document.importNode(card, true));
            });
          }

          bindCards(section);

          if (nextState && nextState.getAttribute('data-vsac-next')) {
            state.setAttribute('data-vsac-next', nextState.getAttribute('data-vsac-next'));
            loadNext();
          } else {
            state.remove();
          }
        })
        .catch(function (error) {
          console.warn('VS Auto Collections:', error);
          var text = state.querySelector('.vsac__load-text');
          if (text) text.textContent = 'More collections available';
          state.classList.add('vsac__load-error');
        });
    }

    loadNext();
  }

  function initVSAC(section) {
    if (!section || section.dataset.vsacInitialized === 'true') return;
    section.dataset.vsacInitialized = 'true';
    bindCards(section);
    autoLoadRemainingCollections(section);
  }

  function initAllVSAC() {
    document.querySelectorAll('.vs-auto-collections').forEach(function (section) {
      initVSAC(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllVSAC);
  } else {
    initAllVSAC();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('.vs-auto-collections')
      : null;
    if (section) initVSAC(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('.vs-auto-collections')
      : null;
    if (section) {
      section.dataset.vsacInitialized = 'false';
      section.dataset.vsacAutoLoading = 'false';
    }
  });
})();
